import { useState } from 'react'

interface ReactionBarProps {
  eventId: string
  onReaction: (type: string) => void
  disabled?: boolean
}

const reactions = [
  { type: 'heart', emoji: '❤️', label: 'ハート' },
  { type: 'thumbsup', emoji: '👍', label: 'いいね' },
  { type: 'sparkles', emoji: '✨', label: 'キラキラ' },
  { type: 'flame', emoji: '🔥', label: '熱い' },
  { type: 'party', emoji: '🎉', label: 'パーティー' },
]

function ReactionBar({ onReaction, disabled = false }: ReactionBarProps) {
  const [selectedReaction, setSelectedReaction] = useState<string | null>(null)
  const [animatingReaction, setAnimatingReaction] = useState<string | null>(null)

  const handleReaction = (type: string) => {
    if (disabled) return

    setSelectedReaction(type)
    setAnimatingReaction(type)
    onReaction(type)

    // アニメーション後にリセット
    setTimeout(() => {
      setAnimatingReaction(null)
    }, 1000)

    // 選択状態を一定時間後にリセット
    setTimeout(() => {
      setSelectedReaction(null)
    }, 3000)
  }

  return (
    <div className="flex items-center gap-1 bg-black/50 backdrop-blur-sm rounded-full px-3 py-2">
      {reactions.map(({ type, emoji, label }) => (
        <button
          key={type}
          onClick={() => handleReaction(type)}
          disabled={disabled}
          className={`
            relative px-3 py-2 rounded-full transition-all duration-200
            ${selectedReaction === type
              ? 'bg-white/20 scale-110'
              : 'hover:bg-white/10 hover:scale-105'
            }
            ${disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}
          `}
          title={label}
        >
          <span
            className={`
              text-2xl inline-block transition-transform
              ${animatingReaction === type ? 'animate-bounce' : ''}
            `}
          >
            {emoji}
          </span>
          {selectedReaction === type && (
            <span className="absolute -top-8 left-1/2 transform -translate-x-1/2 text-white text-sm bg-black/70 rounded px-2 py-1 animate-fade-in">
              {label}
            </span>
          )}
        </button>
      ))}
    </div>
  )
}

export default ReactionBar